var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({staticClass:"icon bookmark-full",class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('path',{attrs:{"d":"m12 17.229-6.419 4.585A1 1 0 0 1 4 21V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a1 1 0 0 1-1.581.814z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }